import ssp1 from "../data/energy/ssp1/baseline.json";
import ssp2 from "../data/energy/ssp2/baseline.json";
import ssp3 from "../data/energy/ssp3/baseline.json";
import ssp4 from "../data/energy/ssp4/baseline.json";
import ssp5 from "../data/energy/ssp5/baseline.json";

import ssp126 from "../data/energy/ssp1/2_6.json";
import ssp226 from "../data/energy/ssp2/2_6.json";
import ssp426 from "../data/energy/ssp4/2_6.json";
import ssp526 from "../data/energy/ssp5/2_6.json";

import ssp134 from "../data/energy/ssp1/3_4.json";
import ssp234 from "../data/energy/ssp2/3_4.json";
import ssp334 from "../data/energy/ssp3/3_4.json";
import ssp434 from "../data/energy/ssp4/3_4.json";
import ssp534 from "../data/energy/ssp5/3_4.json";

import ssp145 from "../data/energy/ssp1/4_5.json";
import ssp245 from "../data/energy/ssp2/4_5.json";
import ssp345 from "../data/energy/ssp3/4_5.json";
import ssp445 from "../data/energy/ssp4/4_5.json";
import ssp545 from "../data/energy/ssp5/4_5.json";

import ssp260 from "../data/energy/ssp2/6_0.json";
import ssp360 from "../data/energy/ssp3/6_0.json";
import ssp460 from "../data/energy/ssp4/6_0.json";
import ssp560 from "../data/energy/ssp5/6_0.json";

const currentYear = data => {
  const rcps = {
    baseline: [ssp1, ssp2, ssp3, ssp4, ssp5],
    "26": [ssp126, ssp226, undefined, ssp426, ssp526],
    "34": [ssp134, ssp234, ssp334, ssp434, ssp534],
    "45": [ssp145, ssp245, ssp345, ssp445, ssp545],
    "60": [undefined, ssp260, ssp360, ssp460, ssp560]
  };
  const { year, ssp, benchmarkSsp } = data;
  const sspData = rcps.baseline;
  const categories = [
    "coal",
    "gas",
    "hydro",
    "nuclear",
    "oil",
    "solar",
    "wind"
  ];

  return categories.map((category, index) => {
    const sspDataCurrent = sspData[ssp - 1];
    const sspDataBenchmark = sspData[benchmarkSsp - 1];

    const currentValue = sspDataCurrent[index][year];
    const benchmarkValue = sspDataBenchmark[index][year];

    const deviationValue = currentValue - benchmarkValue;

    const getRcpValue = rcpScore =>
      rcps[rcpScore][ssp - 1][index][year] || null;

    const getRcpDeviation = rcpScore =>
      rcps[rcpScore][ssp - 1][index][year] - benchmarkValue || null;

    const rcpValues = {
      "26": ssp !== 3 ? getRcpValue("26") : 0,
      "34": getRcpValue("34") !== undefined ? getRcpValue("34") : 0,
      "45": getRcpValue("45") !== undefined ? getRcpValue("45") : 0,
      "60": ssp !== 1 ? getRcpValue("60") : 0
    };
    const rcpDeviations = {
      "26": ssp !== 3 ? getRcpDeviation("26") : 0,
      "34": getRcpDeviation("34") !== undefined ? getRcpDeviation("34") : 0,
      "45": getRcpDeviation("45") !== undefined ? getRcpDeviation("45") : 0,
      "60": ssp !== 1 ? getRcpDeviation("60") : 0
    };

    return {
      ssp,
      benchmarkSsp,
      category,
      value: currentValue,
      benchmarkValue,
      deviationValue,
      rcpValues,
      rcpDeviations
    };
  });
};

const currentCategory = data => {
  const { category, year, ssp, benchmarkSsp } = data;
  const sspData = [ssp1, ssp2, ssp3, ssp4, ssp5];
  const categories = [
    "coal",
    "gas",
    "hydro",
    "nuclear",
    "oil",
    "solar",
    "wind"
  ];

  const categoryIndex = categories.findIndex(c => category === c);

  const energy = sspData[ssp - 1][categoryIndex];
  const benchmarkEnergy = sspData[benchmarkSsp - 1][categoryIndex];

  const deviationValue = energy[year] - benchmarkEnergy[year];

  return {
    ssp,
    benchmarkSsp,
    year,
    deviationValue
  };
};

export default {
  currentYear,
  currentCategory
};



// WEBPACK FOOTER //
// ./src/utils/calcSspDeviation.js